export enum Environment {
    LOCAL = "LOCAL",
    DEV = "DEV",
    STAGING = "STAGING",
    PROD = "PROD"
}

export interface Config {
    environment: Environment;
    showEnvLabel: boolean;
    server: `${string}://${string}`;
}